(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mega-menu-alibaba"] && !Shopify.designMode) return;
  try {
    const alibabaMegaMenu = document.querySelector('.alibaba-mega-menu');

  if (alibabaMegaMenu) {
    const categoryItems = alibabaMegaMenu.querySelectorAll('.alibaba-mega-menu__category-item');
    const categoryGroups = alibabaMegaMenu.querySelectorAll('.alibaba-mega-menu__category-group');
    const contentArea = alibabaMegaMenu.querySelector('.alibaba-mega-menu__content');

    /**
     * Handles the overflow logic for subcategory grids.
     * Ensures only 2 rows are displayed, with the last item being "View All" when overflow occurs.
     */
    class GridOverflowManager {
      constructor(menuElement) {
        this.menu = menuElement;
        this.grids = [];
        this.resizeObserver = null;
        this.initialized = false;

        this.init();
      }

      init() {
        this.grids = this.menu.querySelectorAll('[data-subcategory-grid]');
        if (this.grids.length === 0) return;

        // Use ResizeObserver for reliable size change detection
        this.resizeObserver = new ResizeObserver(this.debounce(() => {
          this.processAllGrids();
        }, 100));

        // Observe each grid for size changes
        this.grids.forEach(grid => {
          this.resizeObserver.observe(grid);
        });

        // Initial processing after a small delay to ensure DOM is ready
        requestAnimationFrame(() => {
          setTimeout(() => {
            this.processAllGrids();
            this.initialized = true;
          }, 50);
        });

        // Also process when menu becomes visible
        this.observeMenuVisibility();
      }

      observeMenuVisibility() {
        const submenu = this.menu.closest('.menu-list__submenu');
        if (!submenu) return;

        const mutationObserver = new MutationObserver(() => {
          // When submenu visibility changes, reprocess grids
          setTimeout(() => this.processAllGrids(), 100);
        });

        mutationObserver.observe(submenu, {
          attributes: true,
          attributeFilter: ['style', 'class', 'aria-hidden']
        });
      }

      processAllGrids() {
        this.grids.forEach(grid => this.processGrid(grid));
      }

      processGrid(grid) {
        const items = Array.from(grid.querySelectorAll('[data-subcategory-item]'));
        const viewAllBtn = grid.querySelector('[data-view-all-btn]');

        if (items.length === 0 || !viewAllBtn) return;

        // Step 1: Reset all items to visible state
        items.forEach(item => {
          item.classList.remove('is-hidden');
          item.style.removeProperty('display');
        });
        viewAllBtn.classList.remove('is-visible');

        // Step 2: Get grid dimensions and calculate items per row
        const gridRect = grid.getBoundingClientRect();
        if (gridRect.width === 0) return; // Grid not visible yet

        const gridStyle = getComputedStyle(grid);
        const gap = parseFloat(gridStyle.gap) || parseFloat(gridStyle.columnGap) || 20;

        // Get a reference item for width calculation
        const firstItem = items[0];
        if (!firstItem) return;

        const itemRect = firstItem.getBoundingClientRect();
        const itemWidth = itemRect.width;

        if (itemWidth === 0) return; // Item not rendered yet

        // Calculate items per row using grid width and item width
        const itemsPerRow = Math.max(1, Math.floor((gridRect.width + gap) / (itemWidth + gap)));

        // Step 3: Calculate max items for 2 rows
        const maxItemsInTwoRows = itemsPerRow * 2;
        const totalItems = items.length;

        // Step 4: If all items fit in 2 rows, no action needed
        if (totalItems <= maxItemsInTwoRows) {
          viewAllBtn.classList.remove('is-visible');
          return;
        }

        // Step 5: We have overflow - hide items and show View All button
        // The View All button takes the last position of row 2
        // So we can show (maxItemsInTwoRows - 1) regular items + View All button
        const visibleItemCount = maxItemsInTwoRows - 1;

        items.forEach((item, index) => {
          if (index >= visibleItemCount) {
            item.classList.add('is-hidden');
          }
        });

        viewAllBtn.classList.add('is-visible');
      }

      debounce(func, wait) {
        let timeout;
        return (...args) => {
          clearTimeout(timeout);
          timeout = setTimeout(() => func.apply(this, args), wait);
        };
      }

      // Public method to trigger recalculation
      refresh() {
        this.processAllGrids();
      }

      destroy() {
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }
      }
    }

    // Initialize the overflow manager
    const overflowManager = new GridOverflowManager(alibabaMegaMenu);

    // Also handle window resize as backup
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        overflowManager.refresh();
      }, 150);
    });

    categoryItems.forEach((item, index) => {
      const categoryLink = item.querySelector('.alibaba-mega-menu__category-link');

      const highlightCategory = () => {
        // Remove active class from all items
        categoryItems.forEach(cat => cat.classList.remove('active'));

        // Add active class to hovered item
        item.classList.add('active');

        // Scroll to the corresponding category group in the content area
        if (categoryGroups[index]) {
          // Calculate the exact position accounting for the content area's padding
          const contentPadding = parseInt(getComputedStyle(contentArea).paddingTop) || 24;
          const groupTop = categoryGroups[index].offsetTop - contentPadding;
          contentArea.scrollTo({
            top: groupTop,
            behavior: 'smooth'
          });
        }

        // Refresh overflow calculations after navigation
        setTimeout(() => overflowManager.refresh(), 150);
      };

      // Prevent navigation and trigger scroll on click only
      categoryLink.addEventListener('click', (e) => {
        e.preventDefault();
        highlightCategory();
      });

      // On desktop with hover support, CSS :hover handles the visual feedback
      // No need to manipulate active class on hover - let active item stay active
    });

    // Optional: Update active state based on scroll position in content area
    if (contentArea && categoryGroups.length > 0) {
      const sidebar = alibabaMegaMenu.querySelector('.alibaba-mega-menu__sidebar');
      let scrollTimeout;
      contentArea.addEventListener('scroll', () => {
        // Debounce scroll event for better performance
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          const scrollTop = contentArea.scrollTop;
          const contentPadding = parseInt(getComputedStyle(contentArea).paddingTop) || 24;

          // Find which group is currently most visible
          let activeIndex = 0;
          categoryGroups.forEach((group, index) => {
            const groupTop = group.offsetTop - contentPadding;

            if (scrollTop >= groupTop - 100) {
              activeIndex = index;
            }
          });

          // Update active state
          categoryItems.forEach(cat => cat.classList.remove('active'));
          if (categoryItems[activeIndex]) {
            categoryItems[activeIndex].classList.add('active');

            // Scroll the sidebar to make the active category item visible
            if (sidebar) {
              const activeItem = categoryItems[activeIndex];
              const sidebarRect = sidebar.getBoundingClientRect();
              const itemRect = activeItem.getBoundingClientRect();

              // Check if item is not fully visible in the sidebar viewport
              if (itemRect.top < sidebarRect.top || itemRect.bottom > sidebarRect.bottom) {
                // Calculate the position to scroll the item into view
                // Center the item in the sidebar viewport
                const itemOffsetTop = activeItem.offsetTop;
                const sidebarHeight = sidebar.clientHeight;
                const itemHeight = activeItem.offsetHeight;
                const scrollPosition = itemOffsetTop - (sidebarHeight / 2) + (itemHeight / 2);

                sidebar.scrollTo({
                  top: scrollPosition,
                  behavior: 'smooth'
                });
              }
            }
          }
        }, 50);
      });
    }
  }
  } catch(e) { console.error(e); }
})();

})();
